import cn from 'classnames';

import { IConDefaultType } from '..';

export enum ThemeIconVariant {
  MOON = 'moon',
  SUN = 'sun',
}

interface IThemeIconProps extends IConDefaultType {
  variant?: ThemeIconVariant;
}

function ThemeIcon({ color, className, size = 24, rotate, flip, variant = ThemeIconVariant.MOON }: IThemeIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === ThemeIconVariant.MOON && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
          <path
            d="M17.5014 10.6583C17.3703 12.0768 16.8379 13.4287 15.9666 14.5557C15.0952 15.6826 13.921 16.5382 12.5811 17.0221C11.2413 17.5061 9.79137 17.5984 8.40097 17.2884C7.01056 16.9784 5.73721 16.2788 4.7299 15.2715C3.7226 14.2642 3.023 12.9908 2.71297 11.6004C2.40295 10.21 2.49531 8.76007 2.97927 7.42025C3.46322 6.08042 4.31874 4.90614 5.44573 4.03479C6.57271 3.16345 7.92455 2.63109 9.34305 2.5C8.51256 3.62356 8.11292 5.00787 8.21683 6.40118C8.32073 7.79448 8.92127 9.10422 9.90922 10.0922C10.8972 11.0801 12.2069 11.6807 13.6002 11.7846C14.9935 11.8885 16.3778 11.4888 17.5014 10.6583Z"
            stroke="#303037"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {variant === ThemeIconVariant.SUN && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
          <g clipPath="url(#clip0_14481_266516)">
            <path
              d="M9.9987 0.832031V2.4987M9.9987 17.4987V19.1654M3.51536 3.51536L4.6987 4.6987M15.2987 15.2987L16.482 16.482M0.832031 9.9987H2.4987M17.4987 9.9987H19.1654M3.51536 16.482L4.6987 15.2987M15.2987 4.6987L16.482 3.51536M14.1654 9.9987C14.1654 12.2999 12.2999 14.1654 9.9987 14.1654C7.69751 14.1654 5.83203 12.2999 5.83203 9.9987C5.83203 7.69751 7.69751 5.83203 9.9987 5.83203C12.2999 5.83203 14.1654 7.69751 14.1654 9.9987Z"
              stroke="#EAEAEC"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_14481_266516">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </i>
  );
}

export default ThemeIcon;
